const FndUserQueryFields = [
    {
        name: '节点名称',
        code: 'nodeName',
        column: true,
        defaultFilter: true,
        width: 200
    },
    {
        name: '路由',
        code: 'target',
        column: true,
        defaultFilter: true,
        width: 120
    },
    {
        name: '菜单路径',
        code: 'path',
        column: true,
        defaultFilter: true
    },
    {
        name: '权限组',
        code: 'permissionName',
        align: 'center',
        defaultFilter: true,
        width: 120
    }
]
export default FndUserQueryFields;